<script>
  import { db } from "../database";
  import { user } from "../stores";

  import TeachCreate from "./TeachCreate.svelte";
  import TeachRun from "./TeachRun.svelte";
  import PageTransitions from "../helpers/PageTransitions.svelte";

  const teacherHasClass = async () => {
    return await db.classes.hasClass($user.uid);
  };

  let create = teacherHasClass();

  const handleCreate = () => {
    create = true;
  };
</script>

<div class="columns">
  <div class="column is-half-desktop is-offset-one-quarter has-text-centered">
    {#await create}
      <progress class="progress is-primary my-6" max="100">15%</progress>
    {:then hasClass}
      {#if hasClass}
        <PageTransitions refresh="run">
          <TeachRun />
        </PageTransitions>
      {:else}
        <PageTransitions refresh="create">
          <TeachCreate on:created={handleCreate} />
        </PageTransitions>
      {/if}
    {/await}
  </div>
</div>
